import React, { useState } from "react"
import ExpenseForm from "./ExpenseForm"
import "./NewExpense.css"

function NewExpense(props) {
	const [isEditing, setIsEditing] = useState(false)

	const saveExpenseDataHandler = (enteredExpenseData) => {
		const expenseData = {
			...enteredExpenseData,
			id: Math.random().toString(),
		}

		props.onAddExpense(expenseData)
		setIsEditing(false)
	}

	const startEditingHandler = () => {
		setIsEditing(true)
	}

	const stopEditingHandler = (props) => {
		setIsEditing(false)
	}

	return (
		<div className='new-expense'>
			{!isEditing && (
				<button onClick={startEditingHandler}>Add Expense.</button>
			)}
			{isEditing && (
				<ExpenseForm
					triggerForm={stopEditingHandler}
					onSaveExpenseData={saveExpenseDataHandler}
				/>
			)}
		</div>
	)
}

export default NewExpense
